export default "__VITE_ASSET__ss3FU$Ie__"